'use client'
import {
  Col,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { BalanceProjectDetails } from './balance-project.details'
import { BalanceProjectHistory } from './balance-project.history'
import { useTranslate } from '@repo/shared/hooks'
import { BalanceProjectTransferHistory } from './balance-project.transfer.history'

export const BalanceProjectContainer = ({
  projectId,
}: {
  projectId: string
}) => {
  const { t } = useTranslate()
  const tabs = [
    {
      value: 'sellAndBuy',
      label: t('walletPage_history_sell_and_buy'),
    },
    {
      value: 'transfer',
      label: t('walletPage_history_transfer'),
    },
  ]
  return (
    <Col className='min-h-screen items-start mb-8xl md:mb-3'>
      <BalanceProjectDetails projectId={projectId} />

      <Tabs
        defaultValue='sellAndBuy'
        color='base'
        size='md'
        scrollable={false}
        className='w-full mt-md'
      >
        <TabsList className='w-full md:w-fit'>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className='w-full'>
            {tab.value === 'sellAndBuy' && (
              <BalanceProjectHistory projectId={projectId} />
            )}
            {tab.value === 'transfer' && (
              <BalanceProjectTransferHistory projectId={projectId} />
            )}
          </TabsContent>
        ))}
      </Tabs>
    </Col>
  )
}
